import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ConfigService } from './config.service';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GtagService {

  private gtagScriptLoaded = false;

  constructor(private configService: ConfigService) { }

  /** Llama a gtag para registrar un evento */
  public event(eventName: string, params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (typeof gtag !== 'undefined') {
        gtag('event', eventName, params);
        resolve(true);
      } else {
        console.error('gtag no está definido. Asegúrate de que gtag.js se haya cargado correctamente.');
        reject({ status: '404', message: 'Comuniquese con el administrador.' });
      }
    });
  }

  /**
   * Injects the Google Tag script dynamically into the document head
   */
  loadGTagScript(): void {
    const sociedadActiva = this.configService.getSociedadActiva();
    const empresaConfig = environment.empresas.find((value) => { return value.sociedad == sociedadActiva });
    if (this.gtagScriptLoaded || !empresaConfig?.googleTagManagerId) {
      return; // Prevent loading script multiple times
    }

    // Create the main gtag script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${empresaConfig!.googleTagManagerId}`;

    // Insert the script tag into the head
    document.head.appendChild(gtagScript);

    // Initialize gtag
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${empresaConfig!.googleTagManagerId}');
    `;

    document.head.appendChild(inlineScript);

    this.gtagScriptLoaded = true;
  }

}
